<div [formGroup]="formGroup" [style.padding-left.px]="control.element.paddingLeft">
  <div [formArrayName]="getFormArrayName(control.element.id)">
    <div class="array-control-group {{ control.element.minimum !== control.element.maximum ? 'array-control-group-list' : ''}}"
         *ngFor="let templateFormGroup of templateFormGroups; let i = index; trackBy: trackIndex">
      <ng-container *ngFor="let customFormControl of templateFormGroup.customFormControls">
        <div [style.flex]="customFormControl.element.width">
          <app-dynamic-control [formGroup]="formGroup"
                               [control]="customFormControl"
                               [formGroupName]="i"
                               [viewModel]="viewModel"
                               [arrayIndex]="i"
                               [controlCache]="controls"></app-dynamic-control>
        </div>
      </ng-container>
      <ng-container *ngIf="i >= control.element.minimum || control.element.alwaysShowDeleteButton">
        <div style="flex: 1; position: relative; display: flex; align-items: flex-end">
          <button id="btn-array-delete-{{i}}" class="btn btn-danger" style="width: 100px" (click)="onArrayDelete(control, i)">Delete <i class="fa-regular fa-trash-can"></i></button>
        </div>
      </ng-container>
    </div>
  </div>
  <div *ngIf="formArray.errors" style="margin-left: 15px">
    <ul>
      <li *ngFor="let error of formArray.errors | keyvalue" style="color: red">
        {{ error.value }}
      </li>
    </ul>
  </div>
  <button id="btn-add-{{control.element.id}}"
          *ngIf="control.element.minimum !== control.element.maximum && control.element.showAddButton === true"
          class="btn btn-primary btn-assessor"
          [disabled]="isArrayFull(control)"
          (click)="addTemplateItem(control)">Add Another</button>
</div>
